<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-alert v-if="hasPendingPlacementTests" type="warning" outlined>It looks like you have pending placement tests in your to-do list. If you have not yet completed one or more placement test, please explain in the comments box why. Your pre-registration may be held until these placement tests are completed unless you can explain why you are not taking them. For example, if you have taken no Spanish or French courses, then explain in the comments "I have not taken the Spanish or French placement test because I have no experience in either of these languages."</v-alert>
        <p>Please include in the box below any comments or additioanl information you wish to share with the new student advisors or that you think they may need to know.</p>
        <v-textarea v-model="comments" label="Comments" outlined></v-textarea>
        <p>This submission of these course requests is not a guarantee that you will be able to get into these classes. We try to honor requests as best as we can but are not always able to do so.</p>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="submit()">Submit Pre-Registration</v-btn>
      <v-btn @click="$emit('back')">Back</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'
export default {
  setup (props, { root, emit }) {
    const form = ref(null)
    const comments = ref('')
    function submit () {
      if (form.value.validate()) {
        let obj = {}
        if (comments.value !== '') obj.comments = comments.value
        emit('submit', obj)
      }
    }

    const pendingToDoList = computed(() => root.$store.state.actions.filter(({ isPlacementTest }) => isPlacementTest === true || isPlacementTest === 'true'))
    const hasPendingPlacementTests = ref(pendingToDoList.value.length > 0)
    onMounted(async () => {
      // Look up the current user's to-do list and see if there are any placement tests that are not makred completed
      if (root.$store.state.term === '') {
        await root.$store.dispatch('loadTracker')
      }
    })

    return {
      form,
      comments,
      submit,
      pendingToDoList,
      hasPendingPlacementTests
    }
  }
}
</script>
